// Where the web app runs: a browser, or the iOS / Android app (Capacitor shell).
// Every difference between them lives in src/native/; the rest of the app asks here.
import { Capacitor } from '@capacitor/core';

export const isNative = () => Capacitor.isNativePlatform();
export const platform = () => Capacitor.getPlatform(); // 'ios' | 'android' | 'web'
export const isIOS = () => platform() === 'ios';
export const isAndroid = () => platform() === 'android';

// The custom URL scheme the apps register; the system browser hands sign-ins back with it.
export const APP_SCHEME = 'day.busybee.app';
// The public site, for pages the apps open in the system browser.
export const WEB_URL = (process.env.REACT_APP_WEB_URL || 'https://busybee.day').replace(/\/$/, '');
